module.exports = "https://web-assets-production.autolist.com/_next/static/images/trending-family-small-9bae9380e7ebab67e407274ec79f5813.jpg";